import {DataStatus, FormControl, FormField} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useWatch} from 'react-hook-form';

import {isNil} from 'ramda';

import {useGetTenantQuery} from '@dms/api/core';
import {useGetAuthorizationProfilesQuery} from '@dms/api/security';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {EmployeeSalesOrganizationalForm} from '../types/EmployeeSalesOrganizationalForm';

interface EmployeeAuthorizationProfilesProps extends TestIdProps {
  control: FormControl<EmployeeSalesOrganizationalForm>;
  index: number;
}

export function EmployeeAuthorizationProfiles(props: EmployeeAuthorizationProfilesProps) {
  const [selectedBranch] = useWatch({
    control: props.control,
    name: [`branches.${props.index}.branchId`],
  });

  const {data: tenant} = useGetTenantQuery();
  const {
    data: authorizationProfiles,
    isLoading,
    isError,
  } = useGetAuthorizationProfilesQuery(
    {'x-tenant': tenant?.id ?? '', branchId: selectedBranch ?? ''},
    {skip: isNil(tenant) || isNil(selectedBranch)}
  );

  return (
    <DataStatus isLoading={isLoading} isError={isError} minHeight={12}>
      <VStack spacing={1}>
        <FormField
          type="multiChoice"
          control={props.control}
          menuInPortal
          isSearchable
          label={i18n.t('page.settings.labels.profiles')}
          name={`branches.${props.index}.authorizationIds`}
          options={
            authorizationProfiles
              ?.filter((profile) => profile.isActive)
              .map((profile) => ({label: profile.name, value: profile.id})) ?? []
          }
        />
      </VStack>
    </DataStatus>
  );
}
